import React, {Component} from 'react';
import grey from '@material-ui/core/colors/grey';
import common from '@material-ui/core/colors/common';
const grey500 = grey['500'];
const white = common.white;
// import PersonAdd from 'material-ui/svg-icons/social/person-add';
// import Help from 'material-ui/svg-icons/action/help';
// import TextField from 'material-ui/TextField';
// import ThemeDefault from '../theme-default';

class Login extends Component {

    static openPopup(url) {
        const width = 600, height = 600;
        const left = (window.innerWidth / 2) - (width / 2);
        const top = (window.innerHeight / 2) - (height / 2);

        return window.open(url, '',
            `toolbar=no, location=no, directories=no, status=no, menubar=no, 
      scrollbars=no, resizable=no, copyhistory=no, width=${width}, 
      height=${height}, top=${top}, left=${left}`
        )
    }

    checkPopup(popup) {
        const check = setInterval(() => {
            if (!popup || popup.closed || popup.closed === undefined) {
                clearInterval(check);
                window.location.replace('/');
            }
        }, 1000)
    }

    startAuth() {
        window.popup = Login.openPopup('/auth/login');
        this.checkPopup(window.popup);
    }

    componentWillMount() {
        // this.startAuth();
        window.location.replace('/auth/login')
    }

    render() {
        return (<div/>);
          {/*<MuiThemeProvider muiTheme={ThemeDefault}>*/}
              {/*<div>*/}
                  {/*<div style={styles.loginContainer}>*/}

                      {/*<Paper style={styles.paper}>*/}

                          {/*<form>*/}
                              {/*<TextField*/}
                                {/*hintText="E-mail"*/}
                                {/*floatingLabelText="E-mail"*/}
                                {/*fullWidth={true}*/}
                              {/*/>*/}
                              {/*<TextField*/}
                                {/*hintText="Password"*/}
                                {/*floatingLabelText="Password"*/}
                                {/*fullWidth={true}*/}
                                {/*type="password"*/}
                              {/*/>*/}

                              {/*<div>*/}
                                  {/*<Checkbox*/}
                                    {/*label="Remember me"*/}
                                    {/*style={styles.checkRemember.style}*/}
                                    {/*labelStyle={styles.checkRemember.labelStyle}*/}
                                    {/*iconStyle={styles.checkRemember.iconStyle}*/}
                                  {/*/>*/}

                                  {/*<Link to="/">*/}
                                      {/*<RaisedButton label="Login"*/}
                                                    {/*primary={true}*/}
                                                    {/*style={styles.loginBtn}/>*/}
                                  {/*</Link>*/}
                              {/*</div>*/}
                          {/*</form>*/}
                      {/*</Paper>*/}

                      {/*<div style={styles.buttonsDiv}>*/}
                          {/*<FlatButton*/}
                            {/*label="Register"*/}
                            {/*href="/"*/}
                            {/*style={styles.flatButton}*/}
                            {/*icon={<PersonAdd/>}*/}
                          {/*/>*/}

                          {/*<FlatButton*/}
                            {/*label="Forgot Password?"*/}
                            {/*href="/"*/}
                            {/*style={styles.flatButton}*/}
                            {/*icon={<Help/>}*/}
                          {/*/>*/}
                      {/*</div>*/}

                      {/*<div style={styles.buttonsDiv}>*/}
                          {/*<Link to="/" style={{...styles.btn, ...styles.btnFacebook}}>*/}
                              {/*<i className="fa fa-facebook fa-lg"/>*/}
                              {/*<span style={styles.btnSpan}>Log in with Facebook</span>*/}
                          {/*</Link>*/}
                          {/*<Link to="/" style={{...styles.btn, ...styles.btnGoogle}}>*/}
                              {/*<i className="fa fa-google-plus fa-lg"/>*/}
                              {/*<span style={styles.btnSpan}>Log in with Google</span>*/}
                          {/*</Link>*/}
                      {/*</div>*/}
                  {/*</div>*/}
              {/*</div>*/}
          {/*</MuiThemeProvider>*/}
    }
}

const styles = {
    loginContainer: {
        minWidth: 320,
        maxWidth: 400,
        height: 'auto',
        position: 'absolute',
        top: '20%',
        left: 0,
        right: 0,
        margin: 'auto'
    },
    paper: {
        padding: 20,
        overflow: 'auto'
    },
    buttonsDiv: {
        textAlign: 'center',
        padding: 10
    },
    flatButton: {
        color: grey500
    },
    checkRemember: {
        style: {
            float: 'left',
            maxWidth: 180,
            paddingTop: 5
        },
        labelStyle: {
            color: grey500
        },
        iconStyle: {
            color: grey500,
            borderColor: grey500,
            fill: grey500
        }
    },
    loginBtn: {
        float: 'right'
    },
    btn: {
        background: '#4f81e9',
        color: white,
        padding: 7,
        borderRadius: 2,
        margin: 2,
        fontSize: 13
    },
    btnFacebook: {
        background: '#4f81e9'
    },
    btnGoogle: {
        background: '#e14441'
    },
    btnSpan: {
        marginLeft: 5
    },
};

export default Login;


// WEBPACK FOOTER //
// ./src/containers/login/Login.js